"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportNRSplitNotReady = exports.reportNRInitializationTimeout = exports.reportNRGetTreatmentResult = exports.reportNRClientInitialized = exports.reportNRMissingUserKey = exports.debugNRPageAction = exports.canNR = void 0;
const env_1 = require("../../utils/env");
const browser_1 = require("../../helpers/browser");
const log_1 = require("../../helpers/log");
const canNR = () => !!(!(0, browser_1.isServerSideRendering)() && window.newrelic);
exports.canNR = canNR;
var NR_PAGEACTION_NAMES;
(function (NR_PAGEACTION_NAMES) {
  NR_PAGEACTION_NAMES["SPLIT_NOT_READY"] = "au_split_error_not_ready";
  NR_PAGEACTION_NAMES["MISSING_USER_KEY"] = "au_split_error_missing_user_key";
  NR_PAGEACTION_NAMES["CLIENT_INITIALIZED"] = "au_split_info_client_initialized";
  NR_PAGEACTION_NAMES["GET_TREATMENT_RESULT"] = "au_split_info_get_treatment_result";
  NR_PAGEACTION_NAMES["INITIALIZATION_TIMEOUT"] = "au_split_error_initialization_timeout";
})(NR_PAGEACTION_NAMES || (NR_PAGEACTION_NAMES = {}));
const debugNRPageAction = (actionName, attributes) => {
  var _a;
  if ((0, browser_1.isServerSideRendering)()) return;
  (0, log_1.debugLog)(actionName, attributes);
  (0, exports.canNR)() && ((_a = window === null || window === void 0 ? void 0 : window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction(`${(0, env_1.getEnv)()}_${actionName}`, attributes));
};
exports.debugNRPageAction = debugNRPageAction;
const reportNRMissingUserKey = () => (0, log_1.debugLog)(NR_PAGEACTION_NAMES.MISSING_USER_KEY, {});
exports.reportNRMissingUserKey = reportNRMissingUserKey;
const reportNRClientInitialized = (trafficType, splitAnonymousUserKey, splitMagentoUserKey, splitMagentoEmail) => (0, exports.debugNRPageAction)(NR_PAGEACTION_NAMES.CLIENT_INITIALIZED, {
  trafficType,
  splitAnonymousUserKey,
  splitMagentoUserKey,
  splitMagentoEmail
});
exports.reportNRClientInitialized = reportNRClientInitialized;
const reportNRGetTreatmentResult = (trafficType, splitName, treatment, splitAnonymousUserKey, splitMagentoUserKey, splitMagentoEmail) => (0, exports.debugNRPageAction)(NR_PAGEACTION_NAMES.GET_TREATMENT_RESULT, {
  trafficType,
  splitName,
  treatment,
  splitAnonymousUserKey,
  splitMagentoUserKey,
  splitMagentoEmail
});
exports.reportNRGetTreatmentResult = reportNRGetTreatmentResult;
const reportNRInitializationTimeout = (trafficType, splitAnonymousUserKey, splitMagentoUserKey, splitMagentoEmail) => (0, exports.debugNRPageAction)(NR_PAGEACTION_NAMES.INITIALIZATION_TIMEOUT, {
  trafficType,
  splitAnonymousUserKey,
  splitMagentoUserKey,
  splitMagentoEmail
});
exports.reportNRInitializationTimeout = reportNRInitializationTimeout;
const reportNRSplitNotReady = (trafficType, splitName, treatment, splitAnonymousUserKey, splitMagentoUserKey, splitMagentoEmail) => (0, exports.debugNRPageAction)(NR_PAGEACTION_NAMES.SPLIT_NOT_READY, {
  trafficType,
  splitName,
  treatment,
  splitAnonymousUserKey,
  splitMagentoUserKey,
  splitMagentoEmail
});
exports.reportNRSplitNotReady = reportNRSplitNotReady;